import { SVGProps } from 'react'

export function CloudUpload(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2.40002 12.0004C2.40002 14.6514 4.54906 16.8004 7.20002 16.8004H10.8V20.4004C10.8 21.0631 11.3373 21.6004 12 21.6004C12.6628 21.6004 13.2 21.0631 13.2 20.4004V16.8004H16.8C19.451 16.8004 21.6 14.6514 21.6 12.0004C21.6 9.34942 19.451 7.20039 16.8 7.20039C16.8 4.54942 14.651 2.40039 12 2.40039C9.34906 2.40039 7.20002 4.54942 7.20002 7.20039C4.54906 7.20039 2.40002 9.34942 2.40002 12.0004ZM13.2 16.8004H10.8V11.2974L9.24855 12.8489C8.77992 13.3175 8.02013 13.3175 7.5515 12.8489C7.08287 12.3803 7.08287 11.6205 7.5515 11.1519L11.1515 7.55186C11.6201 7.08323 12.3799 7.08323 12.8486 7.55186L16.4486 11.1519C16.9172 11.6205 16.9172 12.3803 16.4486 12.8489C15.9799 13.3175 15.2201 13.3175 14.7515 12.8489L13.2 11.2974V16.8004Z'
        fill='currentColor'
      />
    </svg>
  )
}
